import React, { useState, useEffect } from 'react';
import { getExportDeviceById, getDeviceDataByID } from '../../services/deviceService';
import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { Button, Spin } from 'antd';
import { DatePicker, Tooltip } from "antd";
import { showError, showWarning } from '../../services/toastService';

const { RangePicker } = DatePicker;
const getYearMonth = (date) => date.year() * 12 + date.month();

function ExportUI({ userData }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('device');

    const [dates, setDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentDate, setCurrentDate] = useState(dayjs());
    const [macAddress, setMacAddress] = useState('');
    const [deviceName, setDeviceName] = useState('');

    const getDeviceData = async (id) => {
        try {
            setLoading(true);
            const response = await getDeviceDataByID(id, currentDate.format('YYYY-MM-DD'));
            setMacAddress(response?.device?.mac);
            setDeviceName(response?.device?.name);
        } catch (error) {
            console.error('Error fetching device data:', error);
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        getDeviceData(deviceId);
    }, []);

    // Disabled 30 days from the selected date
    // const disabledDaysDate = (current, { from, type }) => {
    //     if (from) {
    //         const minDate = from.clone(); // Start from the selected date
    //         const maxDate = from.clone().add(31, 'days'); // 30 days from the selected date

    //         switch (type) {
    //             case 'year':
    //                 return current.year() < minDate.year() || current.year() > maxDate.year();
    //             case 'month':
    //                 return (
    //                     getYearMonth(current) < getYearMonth(minDate) ||
    //                     getYearMonth(current) > getYearMonth(maxDate)
    //                 );
    //             default:
    //                 return Math.abs(current.diff(from, 'days')) >= 31;
    //         }
    //     }
    //     return false;
    // };
    const disabledDaysDate = (current, { from, type }) => {
        if (from) {
            const minDate = from.clone(); // Start from the selected date
            const maxDate = from.clone().add(30, 'day'); // 30 days from the selected date

            switch (type) {
                case 'year':
                    return current.year() < minDate.year() || current.year() > maxDate.year();
                case 'month':
                    return (
                        getYearMonth(current) < getYearMonth(minDate) ||
                        getYearMonth(current) > getYearMonth(maxDate)
                    );
                default:
                    // Disable days more than 30 days from the selected date or before today
                    return current.isAfter(dayjs()) || Math.abs(current.diff(from, 'day')) >= 30;
            }
        }
        // Disable today and all future dates if no range is selected
        return current && current.isAfter(dayjs());
    };

    const handleDateChange = (dates) => {
        setDates(dates); // Update the state with the selected dates
        console.log('Selected Dates: ', dates);
    };

    const handleExport = async () => {
        try {
            setLoading(true);
            const startDate = dates[0].format('YYYY-MM-DD')
            const endDate = dates[1].format('YYYY-MM-DD')
            console.log('Selected Dates: ', startDate, endDate);
            const response = await getExportDeviceById(deviceId, startDate, endDate);
            if (response) {
                // Extracting the data to be exported from the response
                const dataToExport = response.map(item => item.data).flat(); // Flatten the data array
                console.log(dataToExport)
                // Create CSV header (if needed, change according to your needs)
                const header = Object.keys(dataToExport[0]).join(',') + '\n'; // Create header from the keys

                // Create CSV content
                const csvData = [
                    header, // Add the header to the CSV data
                    ...dataToExport.map(row => Object.values(row).join(',')) // Map each row to CSV format
                ].join('\n');

                // Create a Blob from the CSV data
                const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);

                link.setAttribute('href', url);
                link.setAttribute('download', `${deviceName}-${dates[0].format('DDMMMYYYY')}-${dates[1].format('DDMMMYYYY')}.csv`); // Change filename if necessary
                link.style.visibility = 'hidden';

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                showWarning('Data not available for selected date range. Please try with different dates')
            }
        } catch (error) {
            console.error('Error fetching device data:', error);
            showWarning('Data not available for selected date range. Please try with different dates')
            //showError('Error export data. Please try after sometime.')
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='content-wrappers'>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{deviceName ? deviceName : 'Device Name'} : <small>{macAddress ? macAddress : 'MAC Address'}</small></h3>
                        </div>
                        <div className="card-body">

                            <div className="row">
                                <div className='col-12 text-center'>
                                    <div style={{ margin: '0 20px' }}>
                                        <p>Select the date range to export data</p>
                                        <RangePicker disabledDate={disabledDaysDate} onChange={handleDateChange} />
                                    </div>
                                    <div style={{ margin: '20px' }}>
                                        <Button type='primary' onClick={handleExport} loading={loading}>
                                            Export
                                        </Button>
                                    </div>
                                    <div className='text-danger'>
                                        *Note: Date range allowed maximum 30 days.
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExportUI;
